<template>
  <div>
    <trabajo></trabajo>
    <fotter></fotter>
  </div>
</template>
<script>
import trabajo from "@/components/SobreMiCompont.vue";
import fotter from "@/components/FotterComponent.vue";

export default {
  name: "sobreMi",
  components: {
    trabajo,
    fotter,
  },
};
</script>
